import * as React from 'react';
import { Input, InputProps } from '../index';
import { IconMagnifierSmall } from '../foundation/icons';

export type SearchInputProps = Omit<InputProps, 'type'>;

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>((props, ref) => {
    return <Input {...props} ref={ref} type="search" endAdornmentSlot={<IconMagnifierSmall />} />;
});

SearchInput.displayName = 'SearchInput';
